import React, { useState } from 'react';
import { Grid, Icon, Button } from 'semantic-ui-react';

//
const AdjustTool = ({ options = [] }) => {
	const [test, setTest] = useState(null);
	//
	return <div>AdjustTool</div>;
};

export default AdjustTool;
